import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import {useUpdatePatientMutation}  from '../../redux/services/patientApi';

import CustomSelect from '../common/CustomSelect';


const handlePatientSexUpdate = ({put, patientId}) => async e => {
  const value = e?.target?.value;
  console.log('VAL', value);
  const req = await put({id: patientId, body: {sex: value}});
  return req;
};

const PatientSexAlert = props => {
  const {patient} = props;
  const [put] = useUpdatePatientMutation();
  const onChange = handlePatientSexUpdate({put, patientId: patient.id}); 
  return (
    <Alert severity='warning'>
      <Stack justifyContent='center'>
        Patient sex is required to create a case.
        <CustomSelect 
          name=''
          label={null}
          defaultValue={patient?.sex}
          onChange={e => onChange(e)}
          options={[
            {label: 'Female', value: 'F'},
            {label: 'Male', value: 'M'},
          ]}
        />
      </Stack>
    </Alert>
  );
};

export default PatientSexAlert;